import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourAttentionApi from '@/features/dashboard/tours/api/tourAttentionApi.ts';
import { tourAttentionApiQueryKeys } from '@/features/dashboard/tours/api/tourAttentionApi.queryKeys.ts';
import { TourAttentionDto } from '@/features/dashboard/tours/types/attention/TourAttentionDto.ts';

const useGetTourAttention = (tourId: string) =>
  useQuery(getTourAttentionQueryOptions(tourId));

export const getTourAttentionQueryOptions = (
  tourId: string,
): UseQueryOptions<TourAttentionDto> => ({
  queryKey: tourAttentionApiQueryKeys.byTourId(tourId),
  queryFn: () => tourAttentionApi.getForTour(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60,
});

export default useGetTourAttention;
